// Realistic Bulgarian Dataset for LeadG 2.0 (Burgas Dental Clinics).
// Provides seamless offline/dev fallback when live Supabase credentials are not set.

import type { FindingRow, LeadDetailRow } from '../features/leads/useLeads.js';

export const MOCK_LEADS: LeadDetailRow[] = [
  {
    id: 1,
    business_name: 'Дентално Студио Д-р Иванова',
    city_key: 'burgas',
    area: 'Лазур',
    tier: 'A',
    lead_score: 92,
    priority: 'High',
    phone: '+35956812345',
    phone_source: 'site',
    name_source: 'registry',
    website_url: 'https://drivanova-dental.bg',
    do_not_contact: false,
    domain_norm: 'drivanova-dental.bg',
    parent_lead_id: null,
    branchCount: 0,
    address: 'ул. Александровска 45, Бургас',
    address_source: 'registry',
    normalized_name: 'дентално студио д-р иванова',
    google_place_id: 'ChIJ_drivanova_burgas_1',
    geo_lat: 42.5055,
    geo_lng: 27.4721,
    geo_source: 'osm',
    reputation_band: 'excellent',
    reputation_as_of: '2026-09-01',
    score_breakdown: { speed: 18, seo: 25, reviews: 25, legal: 24 },
    my_notes: 'Разговарях с д-р Иванова. Има интерес към пакета с онлайн записване на часове.',
    vertical_key: 'dentist',
    created_at: '2026-09-01T09:00:00Z',
    rating: 4.9,
    review_count: 48,
    opening_hours: {
      weekdayDescriptions: [
        'Понеделник: 09:00 – 18:30',
        'Вторник: 09:00 – 18:30',
        'Сряда: 09:00 – 18:30',
        'Четвъртък: 09:00 – 18:30',
        'Петък: 09:00 – 17:00',
        'Събота – Неделя: Почивен ден',
      ],
    },
    business_status: 'OPERATIONAL',
    maps_uri: 'https://maps.google.com/?cid=10101',
    sales_stage_id: 2,
    legal_entities: {
      eik: '204112233',
      legal_name: 'ДЕНТАЛНО СТУДИО Д-Р ИВАНОВА ЕООД',
      manager_names: ['Елена Иванова'],
      owner_names: ['Елена Иванова'],
      match_confidence: 95,
    },
  },
  {
    id: 2,
    business_name: 'Дента Център Лазур',
    city_key: 'burgas',
    area: 'Лазур',
    tier: 'A',
    lead_score: 88,
    priority: 'High',
    phone: '+359888123789',
    phone_source: 'site',
    name_source: 'site',
    website_url: 'https://dentallazur.com',
    do_not_contact: false,
    domain_norm: 'dentallazur.com',
    parent_lead_id: null,
    branchCount: 1,
    address: 'бул. Демокрация 104, Бургас',
    address_source: 'site',
    normalized_name: 'дента център лазур',
    google_place_id: 'ChIJ_dentallazur_burgas_2',
    geo_lat: 42.5112,
    geo_lng: 27.4764,
    geo_source: 'osm',
    reputation_band: 'excellent',
    reputation_as_of: '2026-09-02',
    score_breakdown: { speed: 15, seo: 24, reviews: 25, legal: 24 },
    my_notes: 'Сайтът им зарежда бавно на мобилен телефон (>4.8 сек). Добър ъгъл за презентация.',
    vertical_key: 'dentist',
    created_at: '2026-09-02T10:30:00Z',
    rating: 4.8,
    review_count: 36,
    opening_hours: {
      weekdayDescriptions: ['Понеделник – Петък: 08:30 – 19:30', 'Събота: 09:00 – 14:00'],
    },
    business_status: 'OPERATIONAL',
    maps_uri: 'https://maps.google.com/?cid=10102',
  },
  {
    id: 3,
    business_name: 'Специализирана Клиника Бургас Дент',
    city_key: 'burgas',
    area: 'Център',
    tier: 'B',
    lead_score: 74,
    priority: 'Medium',
    phone: '+359879555123',
    phone_source: 'site',
    name_source: 'registry',
    website_url: 'https://burgasdent.bg',
    do_not_contact: false,
    domain_norm: 'burgasdent.bg',
    parent_lead_id: null,
    branchCount: 0,
    address: 'ул. Богориди 22, Бургас',
    address_source: 'registry',
    normalized_name: 'клиника бургас дент',
    google_place_id: 'ChIJ_burgasdent_3',
    geo_lat: 42.4965,
    geo_lng: 27.4745,
    geo_source: 'osm',
    reputation_band: 'good',
    reputation_as_of: '2026-09-03',
    score_breakdown: { speed: 12, seo: 18, reviews: 20, legal: 24 },
    my_notes: 'Нямат SSL сертификат (HTTP само). Липсва политика за бисквитки.',
    vertical_key: 'dentist',
    created_at: '2026-09-03T11:00:00Z',
    rating: 4.4,
    review_count: 19,
    opening_hours: {
      weekdayDescriptions: ['Понеделник – Петък: 09:00 – 18:00'],
    },
    business_status: 'OPERATIONAL',
    maps_uri: 'https://maps.google.com/?cid=10103',
  },
  {
    id: 4,
    business_name: 'Дентална Практика Д-р Георгиев',
    city_key: 'burgas',
    area: 'Възраждане',
    tier: 'B',
    lead_score: 68,
    priority: 'Medium',
    phone: '+359899111222',
    phone_source: 'places',
    name_source: 'places',
    website_url: null,
    do_not_contact: false,
    domain_norm: null,
    parent_lead_id: null,
    branchCount: 0,
    address: 'ул. Гладстон 78, Бургас',
    address_source: 'places',
    normalized_name: 'дентална практика д-р георгиев',
    google_place_id: 'ChIJ_georgiev_4',
    geo_lat: 42.4998,
    geo_lng: 27.4611,
    geo_source: 'osm',
    reputation_band: 'good',
    reputation_as_of: '2026-09-04',
    score_breakdown: { speed: 0, seo: 10, reviews: 18, legal: 20 },
    my_notes:
      'Нямат уебсайт. Присъстват само в Google Maps с 8 добри отзива. Идеален кандидат за пакет Старт.',
    vertical_key: 'dentist',
    created_at: '2026-09-04T12:00:00Z',
    rating: 4.2,
    review_count: 8,
    opening_hours: {
      weekdayDescriptions: ['Понеделник – Петък: 10:00 – 17:00'],
    },
    business_status: 'OPERATIONAL',
    maps_uri: 'https://maps.google.com/?cid=10104',
  },
  {
    id: 5,
    business_name: 'Аполония Дентал ООД',
    city_key: 'burgas',
    area: 'Славейков',
    tier: 'C',
    lead_score: 51,
    priority: 'Low',
    phone: '+35956900111',
    phone_source: 'site',
    name_source: 'registry',
    website_url: 'https://apoloniadent.bg',
    do_not_contact: false,
    domain_norm: 'apoloniadent.bg',
    parent_lead_id: null,
    branchCount: 0,
    address: 'ж.к. Славейков бл. 55, Бургас',
    address_source: 'registry',
    normalized_name: 'аполония дентал оод',
    google_place_id: 'ChIJ_apolonia_5',
    geo_lat: 42.5234,
    geo_lng: 27.4522,
    geo_source: 'osm',
    reputation_band: 'average',
    reputation_as_of: '2026-09-05',
    score_breakdown: { speed: 8, seo: 12, reviews: 11, legal: 20 },
    my_notes: 'Сайт от 2014 г., неадаптивен за мобилни устройства. Липсва ценоразпис.',
    vertical_key: 'dentist',
    created_at: '2026-09-05T14:15:00Z',
    rating: 3.8,
    review_count: 4,
    opening_hours: {
      weekdayDescriptions: ['Понеделник – Петък: 09:00 – 18:00'],
    },
    business_status: 'OPERATIONAL',
    maps_uri: 'https://maps.google.com/?cid=10105',
  },
  {
    id: 6,
    business_name: 'Д-р Димитров - Естетична Стоматология',
    city_key: 'burgas',
    area: 'Меден Рудник',
    tier: 'A',
    lead_score: 85,
    priority: 'High',
    phone: '+359887333444',
    phone_source: 'site',
    name_source: 'site',
    website_url: 'https://dimitrov-smiles.bg',
    do_not_contact: false,
    domain_norm: 'dimitrov-smiles.bg',
    parent_lead_id: null,
    branchCount: 0,
    address: 'ж.к. Меден Рудник, зона А, Бургас',
    address_source: 'site',
    normalized_name: 'д-р димитров естетична стоматология',
    google_place_id: 'ChIJ_dimitrov_6',
    geo_lat: 42.4688,
    geo_lng: 27.4215,
    geo_source: 'osm',
    reputation_band: 'excellent',
    reputation_as_of: '2026-09-06',
    score_breakdown: { speed: 17, seo: 22, reviews: 24, legal: 22 },
    my_notes:
      'Много висок рейтинг в Google (4.9). Търсят разширяване и автоматизиране на записванията.',
    vertical_key: 'dentist',
    created_at: '2026-09-06T15:45:00Z',
    rating: 4.9,
    review_count: 52,
    opening_hours: {
      weekdayDescriptions: ['Понеделник – Петък: 09:00 – 19:00', 'Събота: 10:00 – 15:00'],
    },
    business_status: 'OPERATIONAL',
    maps_uri: 'https://maps.google.com/?cid=10106',
  },
];

export const MOCK_FINDINGS: Record<number, FindingRow[]> = {
  1: [
    {
      id: 101,
      check_key: 'online_booking',
      category: 'capabilities',
      state: 'broken',
      importance: 'high',
      title_bg: 'Бутон за записване води към неработеща форма',
      detail_bg: 'Бутонът „Запиши час“ отваря празен попъп с грешка 404.',
      improvement_bg: 'Интеграция на работещ модул за директен час без прекъсване на разговора.',
      consequence_bg: 'Пациент вечер затваря страницата и звъни на друг кабинет.',
      evidence_text: 'form[action=""] без валиден обработчик',
    },
    {
      id: 102,
      check_key: 'mobile_speed',
      category: 'performance',
      state: 'subpar',
      importance: 'high',
      title_bg: 'Мобилна скорост под препоръчителната (3.4 сек)',
      detail_bg: 'Големи некомпресирани снимки на кабинета забавят зареждането през 4G/5G.',
      improvement_bg: 'Преминаване към WebP/AVIF формат и Next-Gen кеширане за мигновен старт.',
      consequence_bg: 'Над три секунди на телефон и половината посетители вече са в друг резултат.',
      evidence_text: '3420 ms до пълен HTML отговор',
    },
    {
      id: 103,
      check_key: 'gdpr_cookie_notice',
      category: 'legal',
      state: 'missing',
      importance: 'high',
      title_bg: 'Липсва GDPR банер за съгласие за бисквитки',
      detail_bg: 'Зареждат се Google Analytics скриптове преди съгласието на потребителя.',
      improvement_bg: 'Поставяне на законосъобразен банер с двустепенно съгласие по КЗЛД.',
      consequence_bg: 'Формата за запитване без политика е нарушение по ЗЗЛД.',
      evidence_text: null,
    },
    {
      id: 104,
      check_key: 'google_review_widget',
      category: 'visibility',
      state: 'optional_missing',
      importance: 'medium',
      title_bg: 'Отличните отзиви (4.9 ★) не се показват на сайта',
      detail_bg:
        'Кабинетът има 48 петзвездни оценки в Google, но посетителите на сайта не ги виждат.',
      improvement_bg:
        'Динамичен бадж с Google отзиви директно под заглавието на началната страница.',
      consequence_bg: 'Отзивите са в Google, а не на сайта — посетителят ги търси другаде.',
      evidence_text: null,
    },
    {
      id: 105,
      check_key: 'ssl_tls',
      category: 'freshness',
      state: 'ok',
      importance: 'high',
      title_bg: 'Валиден SSL сертификат с автоматично подновяване',
      detail_bg: 'Връзката е криптирана и защитена.',
      improvement_bg: null,
      consequence_bg: null,
      evidence_text: 'https://drivanova-dental.bg/',
    },
  ],
};

export const DEMO_LEGAL_ENTITY = {
  id: 1,
  legal_name: 'ДЕНТАЛНО СТУДИО Д-Р ИВАНОВА',
  eik: '204112233',
  legal_form: 'EOOD',
  company_status: 'Развиващ се',
  registration_date: '2016-05-12',
  registered_seat: 'ул. Александровска 45',
  seat_city: 'Бургас',
  manager_names: ['Елена Иванова'],
  owner_names: ['Елена Иванова'],
  match_confidence: 95,
  match_method: 'eik_on_site',
  registry_dump_date: '2026-10-10',
  source: 'registry_index',
  source_url: 'https://finansi.bg/dent-ivanova-204112233',
  financials: [
    { year: 2024, revenue_bgn: 485000, profit_bgn: 112000, employees: 6 },
    { year: 2023, revenue_bgn: 410000, profit_bgn: 88000, employees: 5 },
  ],
};

export const MOCK_DOSSIER: Record<number, string> = {
  1: `# Досие за контакт: Дентално Студио Д-р Иванова

**Целеви пакет:** Премиум (€2,400) · Месечна поддръжка: €90/мес.  
**Контактно лице:** д-р Елена Иванова (Управител и главен лекар)  
**Телефон:** 056 812 345 (кабинет) · 088 845 6789 (мобилен)
`,
};
